module.exports = __webpack_public_path__ + "img/zhiliang@3x.7c60478b.png";